import { captureException } from '@sentry/react';
import { isTest } from 'config/env';

export const logError = (error: unknown, captureContext?: any) => {
  let errToCapture: Error;

  if (typeof error === 'string') {
    errToCapture = new Error(error);
    errToCapture.name = error;
    captureContext = { description: error, ...(captureContext || {}) };
  } else if (error instanceof Error) {
    errToCapture = error;
  } else if (error && typeof error === 'object') {
    // Extract message from object or serialize to JSON
    let message: string;
    if ('message' in error && typeof error.message === 'string') {
      message = error.message;
    } else {
      try {
        message = JSON.stringify(error, null, 2);
      } catch {
        message = 'Error object (could not serialize)';
      }
    }
    errToCapture = new Error(message);
    captureContext = { originalError: error, ...(captureContext || {}) };
  } else {
    errToCapture = new Error(String(error ?? 'Unknown error'));
  }

  if (isTest) console.error(errToCapture);
  captureException(errToCapture, captureContext);
};
